module.exports = __webpack_public_path__ + "img/zufang.dbd38f17.png";